export enum State {
    initial,
    loading,
    succeed,
    noResults
}
